const formatNumber = (number) => {
  if (number === null || number === undefined || isNaN(Number(number))) {
    return '';
  }

  const parsedNumber = Number(number);
  const parts = parsedNumber.toFixed(2).toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return parts[1] === '00' ? parts[0] : parts.join('.');
};

export default formatNumber;
